import { render } from "./ServerStatus.vue?vue&type=template&id=182d444c"
import script from "./ServerStatus.vue?vue&type=script&lang=js"
export * from "./ServerStatus.vue?vue&type=script&lang=js"
script.render = render

export default script